// src/contexto/CategoriasContext.jsx
import { createContext, useContext, useState } from 'react';
import { obtenerCategorias } from '../../../core/productos/infraestructure/supabase/Categorias.repository.js'

const CategoriasContext = createContext(null);

export const useCategorias = () => {
  const ctx = useContext(CategoriasContext);
  if (!ctx) {
    throw new Error('useCategorias debe usarse dentro de CategoriasProvider');
  }
  return ctx;
};



export function CategoriasProvider({ children }) {
  const [categorias, setCategorias] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState(null);

  const cargarCategorias = async () => {
    if (categorias.length) return; 
    setCargando(true);
    setError(null);

    const res = await obtenerCategorias();

    if (res.success) {
      setCategorias(res.data);
    } else {
      setError(res.error);
    }

    setCargando(false);
  };

  return (
    <CategoriasContext.Provider
      value={{
        categorias,
        cargarCategorias,
        cargando,
        error
      }}
    >
      {children}
    </CategoriasContext.Provider>
  );
}
